var _excluded = ["appearance", "background", "size"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import useStyles from './use_styles';
import { useTheme } from '@veneer/theme';
import IconPlaceholder from '../icons/icon_placeholder';
import { jsx as ___EmotionJSX } from "@emotion/react";
var makeLogo = (name, alt, defaultWidth, defaultHeight, urls, deprecationDate) => {
  var warned = false;
  var Logo = /*#__PURE__*/React.forwardRef((_ref, ref) => {
    var _urls$multicolor, _urls$appearance;
    var {
        appearance: appearanceProp = 'auto',
        background: backgroundProp = 'auto',
        size
      } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);
    var {
      mode
    } = useTheme();
    var darkMode = ['dark', 'contrast'].includes(mode);
    if (process.env.NODE_ENV === 'development' && deprecationDate && !warned) {
      console.warn(["@veneer/core: The ".concat(name, " component has been deprecated and it'll be removed by ").concat(new Date(deprecationDate).toLocaleDateString(), ".")].join(' '));
      warned = true;
    }
    var background = backgroundProp === 'auto' ? darkMode ? 'onDark' : 'onLight' : backgroundProp === 'dark' ? 'onDark' : 'onLight';
    var appearance = appearanceProp !== 'auto' ? appearanceProp : (_urls$multicolor = urls.multicolor) !== null && _urls$multicolor !== void 0 && _urls$multicolor[background] ? 'multicolor' : 'singlecolor';
    var url = (_urls$appearance = urls[appearance]) === null || _urls$appearance === void 0 ? void 0 : _urls$appearance[background];
    var styles = useStyles({
      size,
      defaultWidth,
      defaultHeight
    });
    return url ? ___EmotionJSX("img", _extends({
      alt: alt,
      ref: ref,
      src: url,
      css: styles
    }, props)) : ___EmotionJSX(IconPlaceholder, {
      css: styles,
      "aria-label": alt
    });
  });
  Logo.displayName = name;
  return Logo;
};
export default makeLogo;